<template>
    <div class="ds-gdpr-overlay" :data-src="bg" ref="gdprOverlay">
        <div class="ds-gdpr-overlay__content" ref="gdprOverlayContent">
            <div class="ds-gdpr-overlay__content-inner">
                <h3 class="ds-gdpr-overlay__title">{{ header }}</h3>
                <p class="ds-gdpr-overlay__text">
                    <span v-html="message"></span>
                    <template v-if="videoUrl">
                        <span>
                            Video můžete zhlédnout přímo na webové stránce poskytovatele
                            <a :href="videoUrl" target="_blank" rel="noreferrer"><strong>zde</strong></a
                            >.
                        </span>
                    </template>
                </p>
            </div>

            <div class="ds-gdpr-overlay__actions">
                <DsButton type="primary" theme="dark" @click="consent">{{ button }}</DsButton>
                <DsButton type="secondary" :href="linkUrlCombined" is-external>{{ link }}</DsButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
/* eslint-disable @nx/enforce-module-boundaries */
import { ref, onMounted } from "vue";
import DsButton from "../button/ds-button.vue";
import { useWecomaIntegration } from "@sazka/utils/gdpr/use-wecoma-integration";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { useWebpBackgroundImage } from "@sazka/utils/webp-background-images";
import { WecomaConstants } from "@sazka/utils/gdpr/wecoma-constants";

const { header, message, button, link, linkUrl, bg } = environment.gdprOverlay;
const preferenceCenterLinkUrl = `${appSettings["Integrations:Wecoma:Domain"]}?key=${WecomaConstants.WECOMA_CODE_DEH}&locale=cs-CZ&authKeys=${WecomaConstants.WECOMA_AUTHKEY}&source=thirdpartycontent`;
const linkUrlCombined = linkUrl || preferenceCenterLinkUrl;
const gdprOverlay = ref<HTMLElement | null>(null);
const gdprOverlayContent = ref<HTMLElement | null>(null);

const { consentToThirdParty } = useWecomaIntegration();

const consent = async () => {
    await consentToThirdParty();
    eventBus.emit(GlobalEvents.ConsentsChanged);
};

onMounted(() => {
    gdprOverlay.value.style.minHeight = `calc(${gdprOverlay.value.scrollHeight}px + calc(var(--sp-dynamic-300, 24px) * 2))`;

    useWebpBackgroundImage(gdprOverlay.value);
});

defineProps<{
    videoUrl: string;
}>();

defineExpose({
    gdprOverlayContent,
});
</script>
